import type { Locale } from './config';

/**
 * The only strings app/global-error.tsx renders, per locale
 *
 * Inlined rather than picked from the locale JSON files so the global error
 * chunk does not bundle every locale's messages. Kept in sync with
 * messages/*.json by __tests__/global-error-messages.test.ts.
 */
export const globalErrorMessages: Record<
  Locale,
  { common: { globalErrorTitle: string; globalErrorMessage: string } }
> = {
  en: {
    common: {
      globalErrorTitle: 'An error has occurred',
      globalErrorMessage:
        'We apologize for the inconvenience. Please try refreshing the page.',
    },
  },
  pt: {
    common: {
      globalErrorTitle: 'Ocorreu um erro',
      globalErrorMessage:
        'Pedimos desculpas pelo inconveniente. Por favor, atualize a página.',
    },
  },
  es: {
    common: {
      globalErrorTitle: 'Ha ocurrido un error',
      globalErrorMessage:
        'Pedimos disculpas por las molestias. Por favor, actualice la página.',
    },
  },
};
